/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
import React from "react";
import Popup from "reactjs-popup";
import PropTypes from "prop-types";
import { AiFillCloseCircle } from "react-icons/ai";
import t from "../../utils/translation/translator";
import "./CustomPopup.scss";
import MsxIcons from "../Icons/MsxIcons/MsxIcons";

const CustomPopup = ({
  headerTitle,
  highlightHeaderTitle,
  title,
  text,
  opened,
  cancelLabel,
  cancelAction,
  cancelLoading,
  continueLabel,
  continueAction,
  continueLoading,
  continueDisabled,
  isEmailPopup,
  noPadding,
  onClose,
  fullWidth,
  wideWidth,
  maxWidth,
  fullScreen,
  popUpHeight,
  minimal,
  myref,
  ...props
}) => {
  const contentStyle = {
    maxWidth: maxWidth !== "" ? maxWidth : "550px",
    width: "90%",
    height: popUpHeight || "auto"
  };

  const wideWidthStyle = {
    width: "90%",
    height: popUpHeight || "auto"
  };

  const fullScreenStyle = {
    width: "100vw",
    height: "100vh"
  };

  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <div
      onClick={stopPropagation}
      className={`CustomPopup fixed top-0 left-0 right-0 bottom-0 bg-transparent z-999 ${opened ? "" : "hidden"}`}
      {...props}
    >
      <Popup
        open={opened}
        modal
        contentStyle={
          // eslint-disable-next-line no-nested-ternary
          fullScreen ? fullScreenStyle : wideWidth ? wideWidthStyle : fullWidth ? null : contentStyle
        }
        closeOnDocumentClick={false}
        closeOnEscape={false}
        {...props}
      >
        {() => (
          <div
            ref={myref}
            className={`modal rounded-md flex flex-col max-h-screen h-full overflow-y-auto ${
              !isEmailPopup && !highlightHeaderTitle && "p-3"
            }
            `}
          >
            <div className={`flex justify-between ${isEmailPopup && "p-3"}`}>
              <div
                className={`font-semibold text-base ${
                  highlightHeaderTitle ? "bg-primary text-white w-full p-2" : "text-gray-500"
                } flex items-center justify-between`}
              >
                <span>{headerTitle}</span>
                {onClose && (
                  <MsxIcons
                    name="close"
                    onClick={onClose}
                    className="text-lg text-white cursor-pointer close-modal-btn"
                  />
                )}
              </div>
              {onClose && !highlightHeaderTitle && (
                <AiFillCloseCircle onClick={onClose} className="text-lg text-gray-400 cursor-pointer close-modal-btn" />
              )}
            </div>
            <div
              className={`contentt flex-1 text-gray-600 text-center space-y-6 ${
                !isEmailPopup && !noPadding && "px-4 py-2"
              }`}
            >
              {title && <div className="text-xl font-bold">{title}</div>}
              {text && <div className=" text-base">{text}</div>}
              {props.children}
              {!isEmailPopup && (cancelAction || continueAction) && (
                <div className="flex space-x-2 justify-center">
                  {cancelAction && (
                    <qds-button
                      {...(cancelLoading ? { disabled: "" } : {})}
                      onClick={cancelAction}
                      text={cancelLabel}
                    ></qds-button>
                  )}
                  {continueAction && (
                    <qds-button
                      id="popup-button-continue"
                      importance="emphasized"
                      {...(continueDisabled || continueLoading ? { disabled: "" } : {})}
                      onClick={continueAction}
                      text={continueLabel}
                    ></qds-button>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

CustomPopup.propTypes = {
  headerTitle: PropTypes.string,
  highlightHeaderTitle: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  cancelLabel: PropTypes.string,
  cancelAction: PropTypes.func,
  cancelLoading: PropTypes.bool,
  continueLabel: PropTypes.string,
  continueAction: PropTypes.func,
  continueDisabled: PropTypes.bool,
  opened: PropTypes.bool,
  continueLoading: PropTypes.bool,
  isEmailPopup: PropTypes.bool,
  noPadding: PropTypes.bool,
  onClose: PropTypes.func,
  fullWidth: PropTypes.bool,
  wideWidth: PropTypes.bool,
  fullScreen: PropTypes.bool,
  minimal: PropTypes.bool,
  children: PropTypes.node,
  myref: PropTypes.object,
  maxWidth: PropTypes.string
};

// default props
CustomPopup.defaultProps = {
  headerTitle: "",
  highlightHeaderTitle: false,
  title: null,
  text: null,
  cancelLabel: t("msizer.ui.popup.button.close"),
  cancelAction: undefined,
  cancelLoading: false,
  continueLabel: t("msizer.ui.popup.button.continue"),
  continueAction: undefined,
  continueDisabled: false,
  opened: false,
  continueLoading: false,
  isEmailPopup: false,
  noPadding: false,
  onClose: undefined,
  fullWidth: false,
  wideWidth: false,
  fullScreen: false,
  minimal: false,
  children: null,
  myref: null,
  maxWidth: ""
};

export default CustomPopup;
